import { useState, type DragEvent } from 'react';
import { useGameContext } from '@/state/GameContext';
import type { SlotIndex } from '@/types/domain';

export function CraftingGrid() {
  const game = useGameContext();
  const [dragOver, setDragOver] = useState<number | null>(null);

  const handleDrop = (slot: number, e: DragEvent) => {
    e.preventDefault();
    setDragOver(null);
    const id = e.dataTransfer.getData('text/plain');
    if (id) game.placeItem(slot as SlotIndex, id);
  };

  return (
    <div className="grid-3x3" role="grid" aria-label="Crafting grid">
      {game.grid.map((cell, i) => (
        <div
          key={i}
          className={`slot${cell ? '' : ' empty'}${dragOver === i ? ' drag-over' : ''}`}
          role="gridcell"
          onClick={() => cell && game.clearSlot(i as SlotIndex)}
          onDragOver={(e) => {
            e.preventDefault();
            setDragOver(i);
          }}
          onDragLeave={() => setDragOver((v) => (v === i ? null : v))}
          onDrop={(e) => handleDrop(i, e)}
          title={cell ? 'Click to remove' : 'Drop an item here'}
        >
          {cell ? (
            <img
              src={game.urlFor(cell.itemId)}
              alt={game.metaFor(cell.itemId)?.name || cell.itemId}
              draggable={false}
            />
          ) : null}
        </div>
      ))}
    </div>
  );
}
